/** @file Previewed local values -> one batch: bone.setTransform (Setup) or animation.setKey (Animate). */
import type { Id } from '@pose2d/format/types';
import type { LocalChannel, PreviewValues } from '../../panels/viewport/scene/channelOffset';
import type { PendingCommand } from '../../stores/types';
import type { EditTarget } from './editTargetOf';
import { roundValue } from './roundValue';

/** Map order = batch order; animate keys are absolute values at the rounded frame, rotation raw (no unwrap). */
export function transformCommands(edit: EditTarget, values: ReadonlyMap<Id, PreviewValues>): PendingCommand[] {
  const out: PendingCommand[] = [];
  for (const [target, v] of values) {
    const entries = (Object.entries(v) as [LocalChannel, number][]).map(([c, x]): [LocalChannel, number] => [c, roundValue(x)]);
    if (edit.mode === 'setup') {
      out.push({ name: 'bone.setTransform', input: { target, value: Object.fromEntries(entries) }, ids: [] });
      continue;
    }
    for (const [channel, value] of entries) out.push({ name: 'animation.setKey', input: { animation: edit.animation, target, channel, frame: Math.round(edit.frame), value }, ids: [] });
  }
  return out;
}
